// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderTitle":"c-o_fV"};